import ModelUtil from '@leverege/model-util'

function create( content = null ) {
  return {
    alias : null,
    authorizationUri : null
  }
}

export default {
  create,
  ...ModelUtil.createAllValue( 'alias' ),
  ...ModelUtil.createAllValue( 'authorizationUri' )
}
